// extracted by mini-css-extract-plugin
export default {"main":"qZw_u","title":"l86ei","subtitle":"Vx_HY"};